module.exports = __webpack_public_path__ + "img/down_point_default.be95dec8.svg";